import { CustomerResultAddress } from 'type/address';

export const formatCustomerResultAddress = (address?: CustomerResultAddress) => {
  if (!address) {
    return '';
  }

  const cityLabel = [address.zipCode, address.city].filter(Boolean).join(' ');

  return [address.street, cityLabel, address.countryName].filter(Boolean).join(', ');
};
